// extracted by mini-css-extract-plugin
module.exports = {"specialChar":"styles_specialChar__dOOA2","thunderBolt":"styles_thunderBolt__2o0bs","shape":"styles_shape__tk7jN","bold":"styles_bold__J7AP_"};